import React from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-brand-900 text-brand-100 pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-serif text-white mb-6">Amani Palms</h3>
            <p className="text-brand-200 mb-6 leading-relaxed">
              Your peaceful beachfront escape in Zanzibar. Experience warm hospitality and tropical serenity at Manolo Beach Resort.
            </p>
            <div className="flex flex-col space-y-3">
              <div className="flex items-start space-x-3">
                <FiMapPin className="mt-1 flex-shrink-0" />
                <span>Dikoni Street, Uroa, Tanzania</span>
              </div>
              <div className="flex items-center space-x-3">
                <FiPhone className="flex-shrink-0" />
                <span>+255 677 522 140</span>
              </div>
              <div className="flex items-center space-x-3">
                <FiMail className="flex-shrink-0" />
                <span>contact@manoloresort.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:pl-12">
            <h4 className="text-white text-lg font-serif mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/rooms" className="hover:text-white transition-colors">Rooms</Link></li>
              <li><Link to="/dining" className="hover:text-white transition-colors">Restaurant & Bar</Link></li>
              <li><Link to="/wellness" className="hover:text-white transition-colors">Wellness</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog / Journal</Link></li>
              <li><Link to="/gallery" className="hover:text-white transition-colors">Gallery</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Book Your Stay</Link></li>
              <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white text-lg font-serif mb-6">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/imprint" className="hover:text-white transition-colors">Imprint / Site Notice</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
            <p className="mt-8 text-xs text-brand-400">
              © {new Date().getFullYear()} Amani Palms by Manolo Beach Resort. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;